import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiPatientService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiStaffService ]';
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }

  get() {
  }

  /**
   * 利用者一覧取得API
   * @return Promise<any>
   */
  list(): Promise<any> {
    this.isLoading = true;
    // レスポンス例
    // {
    //   "msg": "success.",
    //   "statusCode": 0,
    //   "patientList": [
    //     {
    //       "patientId":"5f454bfed6fcfc0cbcbfac7e",
    //       "name":"マツダ　有料ろうろう",
    //       "nameKana":"ﾏﾂﾀﾞ ﾕｳﾘｮｳﾛｳﾛｳ",
    //       "gender":"MAN",
    //       "birthday":"19361112",
    //       "makerCode":"PARAMOUNTBED",
    //       "macAddress":"",
    //       "productCode":"nemuriSCAN",
    //       "serialId":"W17B0082",
    //       "sensorId":"5f51dea054028051cf78e48c"
    //     }
    //   ]
    // }
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + '/api/v1/patients',
        body: {}, headers: this.headers
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }


  /**
   * 利用者の一覧と当日のバイタル情報を取得
   * @return Promise<any>
   */
  // listWithVitals(): Promise<any> {
  //   return this.doGet({url: this.apiAuthStore.url + '/api/v1/vitals/current', headers: this.headers}).then((res) => {
  //     if (!res) Promise.reject(null);
  //     switch (res.status) {
  //       case 200:
  //         return Promise.resolve(res.json())
  //       default:
  //         return Promise.reject(null);
  //     }
  //   })
  // }

  /**
   * 登録処理
   * @param params
   */
  post(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/patient',
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  /**
   * 一括登録処理
   * @param params
   */
  bulkPost(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/patient/bulk',
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  /**
   * 更新処理
   * @param params
   */
  update(params, message = null): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/patient/${params.patientId}`,
        body: params, headers: this.headers
      }, message).subscribe(response => resolve(response))
    })
  }

  /**
   * 物理削除処理
   * @param params
   */
  delete(params) {
    return new Promise((resolve) => {
      return this.doDelete({
        url: this.apiAuthStore.url + `/api/v1/patient/${params.patientId}`,
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }


  /**
   * 論理削除処理
   * @param params
   */
  softDelete(params) {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + `/api/v1/patient/${params.patientId}/soft`,
        body: params,
        headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }


  /**
   * 利用者情報を検索するAPI
   *
   *  - 検索に見つかった利用者IDを返す
   *
   * @return Promise<any>
   */
  search(query, showLoading: boolean = false): Promise<any> {
    let loading;
    if (showLoading) {
      loading = this.loadingCtrl.create({
        content: '検索中...'
      });
      loading.present();
    }

    let queryString = Object.keys(query).map((key) => `${key}=${query[key]}`).join('&');

    this.isLoading = true
    return new Promise((resolve) => {
      return this.doGet({
        url: this.apiAuthStore.url + `/api/v1/patientsSearch?${queryString}`,
        body: {}, headers: this.headers
      }
      ).finally(() => {
        this.isLoading = false;
        if (loading) loading.dismiss();
      }).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * 睡眠センサーに紐づく利用者一覧取得API
   * @return Promise<any>
   */
  listWithSleepSensor(targetDate: string = null): Promise<any> {
    this.isLoading = true

    let url = this.apiAuthStore.url + '/api/v1/patients/sensor/sleep';
    if (targetDate) {
      url += `?targetDate=${targetDate}`
    }
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  getSleepLogs(sensorId: string, targetDate: string = null): Promise<any> {
    this.isLoading = true

    let url = this.apiAuthStore.url + `/api/v1/patients/sensor/logs?sensorId=${sensorId}`;
    if (targetDate) {
      url += `&targetDate=${targetDate}`
    }

    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }

  /**
   * 期間指定でバイタルの一覧を取得するAPI
   */
  async getVitalOutputCSV(patientId: string, start: number, end: number): Promise<any> {
    const url = `${this.apiAuthStore.url}/api/v1/vitals/${patientId}/csvoutput?start=${start}&end=${end}`;
    return new Promise((resolve) => {
      return this.doGet({
        url, body: {}, headers: this.headers
      }
      ).finally(
        () => this.isLoading = false
      ).subscribe(
        response => resolve(response)
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-patient.service.ts